import { render, staticRenderFns } from "./PurchaseAddonModal.vue?vue&type=template&id=5dbb898a&"
import script from "./PurchaseAddonModal.vue?vue&type=script&lang=js&"
export * from "./PurchaseAddonModal.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseAddonModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "PurchaseAddonModal.vue"
export default component.exports